export default [
  {
    path: '/roles-list',
    name: 'roles-list',
    component: () => import('@/views/roles/roleList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Roles',
      parent: 'RolesList',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Roles List', active: true }
      ],
      permissions: ['role_list']
    }
  },
  {
    path: '/add/role',
    name: 'add-role',
    component: () => import('@/views/roles/addRole.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Role',
      parent: 'RolesList',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Roles List', url: '/roles-list' },
        { title: 'Add Role', active: true }
      ],
      permissions: ['role_create']
    }
  },
  {
    path: '/role-permission/:id/edit',
    name: 'edit-role-permission',
    component: () => import('@/views/roles/editRolePermission.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Role Permission',
      parent: 'RolesList',
      // breadcrumb: [
      //   { title: 'Dashboard', url: '/' },
      //   { title: 'Roles List', url: '/roles-list' },
      //   { title: 'Edit Role Permission', active: true }
      // ],
      permissions: ['role_edit']
    }
  },
  {
    path: '/role/:id/edit',
    name: 'edit-role',
    component: () => import('@/views/roles/editRole.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Role',
      parent: 'RolesList',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Roles List', url: '/roles-list' },
        { title: 'Edit Role', active: true }
      ],
      permissions: ['role_edit']
    }
  }
]
